export default __webpack_public_path__ + "static/media/resizeToBig.62a0c6ab.svg";